<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12">
                        <div class="row nav-top">
                            <div class="col-3 xtl tf-14"><span onclick="window.location.href='#/rechargerecord'">Records</span></div>
                            <div class="col-6 tfw-7 tf-18">Recharge</div>
                            <div class="col-3 xtr tf-14"><span onclick="rchl()">Help</span></div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-3 xtc">
                                <div class="tf-16 mb-2 tfcdg">Balance</div>
                                <div class="tf-24 tfw-7 tffss tfcdb"><span class="tf-28" id="">{{this.balance}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pd1628">
                        <div class="xtl tf-18 tfw-6 tfcdb">Amount</div>
                        <div class="inpbcx rc nxb tfcb"><span class="xicon rc"></span> <input type="tel"
                                class="xbox rcamt" maxlength="10" placeholder="200 ~ 50000" autocomplete="off"
                                id="recharge"></div>
                        <div class="row" id="rcblt">
                            <div class="col-12 xtl mb-4 tf-20 pl-0 dipn" id="rcbsh"><input class="hw-20" type="radio"
                                    id="bonc"><span class="pl-2 tf-16" id="bonps">5% Bonus</span></div>
                        </div>
                        <div class="row" id="alst">
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(200)" >200</div>
                            </div>
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(560)">560</div>
                            </div>
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(1920)">1920</div>
                            </div>
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(2300)">2300</div>
                            </div>
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(8000)">8000</div>
                            </div>
                            <div class="col-4 pda5">
                                <div class="add-amt" @click="amount(30000)">30000</div>
                            </div>
                        </div>
                        <div class="pa-0 mt-2 mb-2">
                            <div class="btn-main act" @click="proceed()">Recharge</div>
                        </div>
                        <div class="mt-4 tf-16 tfcdg" id="rcann"></div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer">
                    <div class="col-12 nav-bar" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem" id="moxht2b4u" onclick="window.location.href='#/'">
                                    <div class="xtc"><span class="icon home" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="raeiyf2m0" onclick="window.location.href='#/promotion'">
                                    <div class="xtc"><span class="icon group" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="sfrm6bvy" onclick="window.location.href='#/recharge'">
                                    <div class="xtc"><span class="icon wallet sel" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="mcpnvd2my" onclick="window.location.href='#/mine'">
                                    <div class="xtc"><span class="icon my" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof"></div>
                <div class="row" id="dta_ref">
                        <div class="col-12 conod LR"  id="snackbar" style="display :none;">
                            <div class="ssmg fadein" >
                                <div class="tf-14" id="smgid" style="font-size: larger;">Check recharge amount!</div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "RechargeView",
    data() {
        return {
            username: null,
            balance: 0.00,
        }

    },
    mounted: function () {
        this.getUserdetails()
    },
    methods: {
        amount(val) {
            document.getElementById("recharge").value = val;
        }
        ,
        getUserdetails() {

            this.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.username).then((res) => {
                this.Users = res.data.user_Data;

                this.balance = this.Users[0].balance;

                console.log(this.Users);
            }).catch((err) => {
                console.log(err);
            })
        },
        proceed() {


            if (document.getElementById("recharge").value > 199) {
                var link = "https://fiewin.source-code.co.in/payment/payment.php?user=" + this.username + "&am="
                var amount = document.getElementById("recharge").value;
                var payurl = link.concat(amount);
                window.open(payurl, "_blank");
            }
            else {
                alert("Minimum recharge 200")
                var x = document.getElementById("snackbar");
                x.style.display = "";
                setTimeout(function e() { x.style.display = "none"; }, 1000);

            }
        }
    }

}
</script>